export default __webpack_public_path__ + "static/media/submitIcon.bb7c5495.svg";